import PropTypes from 'prop-types';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import typography from 'assets/theme/base/typography';

function Footer({ light }) {
  const { size } = typography;

  return (
    <MDBox position="absolute" width="100%" bottom={0} py={4}>
      <Container>
        <MDBox
          width="100%"
          display="flex"
          flexDirection={{ xs: 'column', lg: 'row' }}
          justifyContent="center"
          alignItems="center"
          px={1.5}
        >
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            color={light ? 'white' : 'text'}
            fontSize={size.sm}
          >
            &copy; {new Date().getFullYear()}{' '}
            <Link href="https://jcgn.org" target="_blank" rel="noopener noreferrer">
              <MDTypography
                variant="button"
                fontWeight="medium"
                color={light ? 'white' : 'dark'}
              >
                &nbsp;JCGN&nbsp;
              </MDTypography>
            </Link>
            Delivery Service
          </MDBox>
        </MDBox>
      </Container>
    </MDBox>
  );
}

Footer.defaultProps = {
  light: false,
};

Footer.propTypes = {
  light: PropTypes.bool,
};

export default Footer;
